export default "__VITE_ASSET__CnDr27eh__"